import React, { useState } from 'react'
import Modal from '../../ReusableComponents/Modal'
import { CrossCloseButton } from '../../Components/Helper'
import { GLOBAL_STYLES } from '../../appConstants'
import dateFormat from 'dateformat'

export default function CallHistoryDetails({
    open, onClose, data, callback,
}) {
    console.log(open,data)

    return (
        <Modal
            open={open}
            onClose={onClose}
            contentStyle={{ height: "auto", width: "625px", borderRadius: "10px", overflow: "hidden" }}>
            <div style={{ height: "100%", background: "rgb(244, 244, 244)", padding: "0px 0px 20px 0px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", background: "#D9D9D9D9", padding: "20px",paddingBottom:"6px" }}>

                    <div style={{  gap: "10px" }}>
                        <div style={{ fontSize: "14px" }}>Call Detail </div>
                    </div>
                    <CrossCloseButton style={{display:"block",padding:"0px"}} onClick={onClose} />
                </div>
                <div style={{ overflowY: "auto", height: "calc(100% - 50px)", fontSize: GLOBAL_STYLES.FONT_SIZE_MEDIUM, padding: "20px" }}>
                    {/* <div style={{ fontWeight: 600, margin: "10px 0px" }}>Call History Detail</div> */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>{data.callbyname == 'System' ? 'Closed By' : "Call By"}</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.callbyname || "-"}</div>
                        </div>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Current Request Status</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.current_req_status || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Call Note</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.note || "-"}</div>
                        </div>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Request Note</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.requestnote || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Call Status</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.status || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Duration</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.time || "-"}</div>
                        </div>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Request Status</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{data?.reqstatus || "-"}</div>
                        </div>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Date Created</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{ dateFormat(data.dateadded,'dd/mm/yyyy hh:MM TT') || "-"}</div>
                        </div>

                        

                    </div>

                </div>

            </div>
        </Modal>
    )
}
